import { Hero } from "../components/Hero";
import { ServiceComplet } from "../components/ServiceComplet";
import { RealisationsPreview } from "../components/RealisationsPreview";
import { HomeCta } from "../components/HomeCta";

export default function Home() {
  return (
    <>
      <Hero />
      <ServiceComplet />
      <RealisationsPreview />
      <HomeCta />
    </>
  );
}
